import React from "react";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    float: "right"
  },
  mBottom: {
    marginBottom: "20px"
  },
  button: {
    margin: theme.spacing(3, 0, 2)
  }
}));

export default function Academic() {
  const classes = useStyles();

  return (
    <Container component="main" maxWidth="md">
      <CssBaseline />
      <div className={classes.paper}>
        <form className={classes.form} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.mBottom}>
              <Typography>
                {" "}
                NAME, TOWN AND YEARS OF ALL PRIMARY AND SECONDARY SCHOOLS
                ATTENDED{" "}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>OPTION 1</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                autoComplete="name of school"
                name="nos"
                variant="outlined"
                required
                fullWidth
                id="nos"
                label="Name of School"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="ts"
                label="Town Schooled"
                name="ts"
                autoComplete="town schooled"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="from"
                label="From"
                type="number"
                name="from"
                autoComplete="from"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="to"
                label="To"
                type="number"
                id="to"
                autoComplete="to"
              />
            </Grid>

            {/* Option2 */}
            <Grid item xs={12}>
              <Typography>OPTION 2</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                autoComplete="name of school"
                name="nos"
                variant="outlined"
                required
                fullWidth
                id="nos"
                label="Name of School"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="ts"
                label="Town Schooled"
                name="ts"
                autoComplete="town schooled"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="from"
                label="From"
                type="number"
                name="from"
                autoComplete="from"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="to"
                label="To"
                type="number"
                id="to"
                autoComplete="to"
              />
            </Grid>
            {/* End of option 2 */}

            {/* Option3 */}
            <Grid item xs={12}>
              <Typography>OPTION 3</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                autoComplete="name of school"
                name="nos"
                variant="outlined"
                required
                fullWidth
                id="nos"
                label="Name of School"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="ts"
                label="Town Schooled"
                name="ts"
                autoComplete="town schooled"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="from"
                label="From"
                type="number"
                name="from"
                autoComplete="from"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="to"
                label="To"
                type="number"
                id="to"
                autoComplete="to"
              />
            </Grid>
            {/* End of option 3 */}

            {/* Option 4 */}
            <Grid item xs={12}>
              <Typography>OPTION 4</Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                autoComplete="name of school"
                name="nos"
                variant="outlined"
                required
                fullWidth
                id="nos"
                label="Name of School"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="ts"
                label="Town Schooled"
                name="ts"
                autoComplete="town schooled"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="from"
                label="From"
                type="number"
                name="from"
                autoComplete="from"
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="to"
                label="To"
                type="number"
                id="to"
                autoComplete="to"
              />
            </Grid>
            {/* End of option 4 */}
          </Grid>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            component={Link}
            to="personal-information"
          >
            Back
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
            component={Link}
            to="parent-guardian"
          >
            Next
          </Button>
        </form>
      </div>
    </Container>
  );
}
